import React from 'react'

const TenantTableHead = () => {
    return (
        <thead className="TableHead SettingTeantDealerItem">
        <tr>
            <th className="No">STT</th>
            <th className="ParentName">Tenant cha</th>
            <th className="TenantName">Tenant con</th>
            <th className="License">License</th>
            <th className="ExtUsed">Đã sử dụng</th>
            <th className="Actions text-center">View</th>
            <th className="Actions text-center">Action</th>
        </tr>
        </thead>
    )
}

export default TenantTableHead